import { useCallback, useEffect } from 'react';
import { isBrowser } from '@zapier/common-utils';
import { TrackPropsType } from '../types';

function useTrackEntry(
  { track, trackingMessage, trackingProps }: TrackPropsType = {
    track: () => {},
  }
) {
  function trackEntry() {
    if (isBrowser()) {
      const message = trackingMessage || 'track entry';
      track(message, { ...trackingProps });
    }
  }

  const trackEntryCallback = useCallback(trackEntry, []);

  useEffect(trackEntryCallback, [trackEntryCallback]);
}

export default useTrackEntry;
